// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("VipTier", {
  id: __t.u32(),
  name: __t.string(),
  priceCentsMonthly: __t.u32(),
  stripePriceId: __t.string(),
  maxPrivatePlayers: __t.u32(),
  maxSpectators: __t.u32(),
  maxFriends: __t.u32(),
  monthlyCoinBonus: __t.i64(),
  coinEarnMultiplierX100: __t.u32(),
  storeDiscountPercent: __t.u32(),
  dailyDealSlots: __t.u32(),
  maxBioLength: __t.u32(),
  adFree: __t.bool(),
  emoteCount: __t.u32(),
  bpXpMultiplierX100: __t.u32(),
  luckyTilesBonusPicks: __t.u32(),
});


